'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationCallMerge = function CommunicationCallMerge(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
  );
};
CommunicationCallMerge = (0, _pure2.default)(CommunicationCallMerge);
CommunicationCallMerge.displayName = 'CommunicationCallMerge';
CommunicationCallMerge.muiName = 'SvgIcon';

exports.default = CommunicationCallMerge;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/communication/call-merge.js
// module id = 1189
// module chunks = 0